import './assets/main.css'
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config';
import Toast from "vue-toastification";
import 'vue-toastification/dist/index.css'


import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// Global image fallback: any <img> that fails to load (e.g. an uncached product image or
// payment icon while offline) is swapped to a neutral placeholder instead of the browser's
// broken-image glyph. Cached images are unaffected. The placeholder is precached so it's
// always available offline. Uses capture phase since resource error events don't bubble.
const IMG_PLACEHOLDER = '/img-placeholder.svg';
window.addEventListener('error', (event) => {
  const el = event.target;
  if (el instanceof HTMLImageElement
      && el.dataset.imgFallback !== '1'
      && !el.src.endsWith(IMG_PLACEHOLDER)) {
    el.dataset.imgFallback = '1';
    el.src = IMG_PLACEHOLDER;
  }
}, true);

const app = createApp(App)
app.config.devtools = true;

app.use(createPinia())
app.use(router)
app.use(PrimeVue)
app.use(Toast , {
  position: "bottom-left",})

app.mount('#app')
